import { widgetApi } from "../services/api";

interface CashDepositLinkApiResponse {
  success: boolean;
  data: {
    url: string;
    linkId: string;
  };
}

/**
 * Mints a cash-deposit `operation_payment` magic link for an operation parked
 * at the funding gate, then returns the URL to hand the sender into the
 * cash-deposit widget (stores + barcode).
 *
 * POST /widget/links/:linkId/operations/:operationId/cash-deposit-link
 */
export const createCashDepositPaymentLink = async (
  linkId: string,
  operationId: string,
  callbackUrl: string
): Promise<{ url: string; linkId: string }> => {
  const { data } = await widgetApi.post<CashDepositLinkApiResponse>(
    `/widget/links/${linkId}/operations/${operationId}/cash-deposit-link`,
    { callbackUrl }
  );
  return data.data;
};

/** Funding sub-statuses that still need the cash-deposit (pay-at-store) flow. */
export const isUnfundedCashDeposit = (
  fundingMethod?: string | null,
  fundingStatus?: string | null
): boolean =>
  fundingMethod === "CASH_DEPOSIT" &&
  (fundingStatus === "awaiting_funding" || fundingStatus === "barcode_issued");
